import TemplatePages from "@/partial/template";

export default function TemplatePage() {
  return <TemplatePages />;
}
